export { default } from './CheckCircleOutline'
